import { group } from "d3-array";
import { Entidad } from "../../data/Entidad";
import { _DICC_ALUMNO_FULL, _SvAlumnoEditar } from "../../data/modulo/Alumno";
import { _DICC_ESCOLARIDAD } from "../../data/modulo/Escolaridad";
import { _DICC_ESCUELA } from "../../data/modulo/Escuela";
import { _DICC_GRADO } from "../../data/modulo/Grado";
import { DataModuloMain } from "../../data/ModuloMain";
import _L from "../../util/Labels";
import { IConfigGridExcelExport, IGridExtraTableConfig, IGridRenderInfo, VentanaGrid } from "../controlD3/AVentanaGrid";
import { ExcelThings } from "../controlD3/ExcelExport";
import { FormGenerator, IField } from "../controlD3/Formulario";
import { SelectV2 } from "../controlD3/SelectV2";
import { Table } from "../controlD3/Tabla";
import { UIUtilIconResources } from "../util/IconResourses";
import { UIUtilPermission } from "../util/Permission";
import { UIUtilTime } from "../util/Time";
import { UIUtilGeneral } from "../util/Util";
import { UIUtilViewData } from "../util/ViewData";
import { UIUtilViewAlumno } from "../utilView/Alumno";

import CAccionPermiso = Entidad.CAccionPermiso;
import IAlumno = Entidad.IAlumno;
interface IAlumnoGraduado extends IAlumno { }

export class UIVentanaAlumnosGraduados extends VentanaGrid<IAlumnoGraduado> {

    protected GRID_GetDataRequestID(): DataModuloMain.TipoRequestMonitorId {
        return Entidad.CTipoRequest.Alumno;
    }

    protected GRID_GetMenuTopGrid(): Array<Table.ITableMenuTopDefaultOptionConfig> {
        return [];
    }

    protected GRID_GetSelectionDataMenuV2(menuLocation: "row" | "top-selected", dataGridSelected: IAlumnoGraduado[]): Table.ITableMenuDataSelectedOptionConfig<IAlumnoGraduado>[] {
        let opts: Array<Table.ITableMenuDataSelectedOptionConfig<IAlumnoGraduado>> = [];
        if (this.GridHasPermisoAccionV2(CAccionPermiso.Editar)) {
            opts.push({
                Label: "action_movefromschool", MultiData: false, Callback: (data) => {
                    this.OpenModal_FormularioEditar(data[0]);
                }
            })
        }

        return opts;
    }

    protected GRID_GetFilters(): Table.IParametroFiltro<IAlumnoGraduado>[] {
        return [
            { LabelLangKey: "d_field_nombre", Field: "Nombre" },
            { LabelLangKey: "d_field_appaterno", Field: "ApPaterno" },
            { LabelLangKey: "d_field_apmaterno", Field: "ApMaterno" },
            { LabelLangKey: "d_field_matricula", Field: "Matricula" },
            { LabelLangKey: "d_field_fechanacimiento", Field: "FechaNacimiento", Type: "date", MaxDate: new Date().toISOString() },
            {
                LabelLangKey: "d_field_strsexo",
                Field: "Sexo",
                Type: "select",
                Options: UIUtilViewData._GetList_Sexo()
            },
            { LabelLangKey: "d_field_strescolaridad", Field: "StrEscolaridad" },
            { LabelLangKey: "d_field_strgrado", Field: "StrGrado" },
        ];
    }

    protected GRID_GetTableConfigBase(): IGridRenderInfo<IAlumnoGraduado> {
        return {
            IdTabla: "AlumnosGraduados",
            Title: "",
            DefaultSort: "NombreCompleto",
            IdData: "IdChild",
            MaxOptionsInRow: 3,
            MinWidth: 1400,
            MenuInRowNoCellsToIgnoreWidth: 2,
            Columns: [
                { Field: "getThumbnailURL", LabelLangKey: null, Label: "", Width: "4%", MinWidth: "30px", IsSortable: false, Align: "center", Icon: UIUtilIconResources.CGeneral.User },
                { Field: "NombreCompleto", Label: "", Width: "20%", MinWidth: "140px" },
                { Field: "Matricula", Label: "", Width: "10%", MinWidth: "110px" },
                { Field: "FechaNacimiento", Label: "", Width: "10%", MinWidth: "110px" },
                { Field: "StrSexo", Label: "", Width: "10%", MinWidth: "110px" },
                { Field: "NombreKinder", Label: "Escuela", Width: "15%", MinWidth: "150px" },
                { Field: "StrEscolaridad", Label: "", Width: "14%", MinWidth: "140px" },
                { Field: "StrGrado", Label: "", Width: "10%", MinWidth: "110px" },
            ]
        }
    }

    protected async GridGetData(): Promise<IAlumnoGraduado[]> {
        let data = Array.from(_DICC_ALUMNO_FULL.values());
        return data.filter(d => d.IdChildMovimiento == Entidad.CNinioMovimiento.Graduado);
    }

    protected GRID_GetTableConfigAdvanced(): IGridExtraTableConfig<IAlumnoGraduado> {
        return {
            EvaluatorAndSubLevelsBuild: {
                OnStepCellTable: (container, datum, field: keyof IAlumno) => {
                    if (field == "getThumbnailURL") {
                        UIUtilViewAlumno._UIUpdateFotoAlumno(container, datum, false);
                    }
                    if (field == "NombreCompleto") {
                        UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", datum.IdChild, datum.NombreCompleto, null, "palumnofotos");
                    }
                    if (field == "FechaNacimiento") {
                        container.text(datum.getFechaNacimientoFmt);
                    }
                }
            }
        }
    }

    protected GRID_GetExportarConfig(dataGrid: IAlumnoGraduado[]): IConfigGridExcelExport<IAlumnoGraduado> {
        return {
            IdsEscuelas: [],
            ColumnsConfig: this.ctrlTabla
                ._InfoColumns
                .filter(d => (d.Field != "getThumbnailURL"))
                .map<ExcelThings.IColumnToExcelExportFileConfig<IAlumnoGraduado>>(d => ({
                    Field: (d.Field == "FechaNacimiento" ? "getFechaNacimientoFmt" : d.Field),
                    HeaderTag: d.Label,
                    WidthCell: (d.Field == "NombreCompleto" ? 35 : 20),
                })),
            OnGetDataBySheets: async () => {
                return Array.from(group(dataGrid, d => d.IdKinder))
                    .map<ExcelThings.ISheetConfig<IAlumno>>(([idEscuela, alumnos]) => ({
                        IdSheet: idEscuela,
                        SheetName: alumnos[0].NombreKinder,
                        Data: alumnos
                    }))
            },
            OnGetEscuelasTagInSheet: (datos) => datos[0].NombreKinder,
        }
    }

    private OpenModal_FormularioEditar(dataOrigin: IAlumnoGraduado) {
        this.GridOpenModal_ActionFormToAGridData({
            Title: _L("alumnosgraduados.title_movefromshcool", dataOrigin.NombreCompleto),
            Action: CAccionPermiso.Editar,
            IdsEscuelas: [dataOrigin.IdKinder],
            GetForm: () => this._GetStudentForm(dataOrigin),
            OnAccept: async (form, mt) => {
                let dataForm = form._Data;
                if (dataOrigin.IdKinder == dataForm.IdKinder) {
                    this.notificacion._Mostrar(_L("alumnosgraduados.notif_noschoolchangeselected"), "ADVERTENCIA");
                    return null;
                }
                return this._SvAlumnoGraduadoMoverDeEscuela(dataOrigin, { IdKinder: dataForm.IdKinder, IdEscolaridad: dataForm.IdEscolaridad, IdGrado: dataForm.IdGrado });
            }
        })
    }

    private async _SvAlumnoGraduadoMoverDeEscuela(dataOrigin: IAlumnoGraduado, MovementDetails: Pick<IAlumnoGraduado, "IdKinder" | "IdEscolaridad" | "IdGrado">) {
        dataOrigin.IdKinder = MovementDetails.IdKinder;
        dataOrigin.IdEscolaridad = MovementDetails.IdEscolaridad;
        dataOrigin.IdGrado = MovementDetails.IdGrado;
        dataOrigin.IdChildMovimiento = Entidad.CNinioMovimiento.Preinscripcion;

        const res = await _SvAlumnoEditar(dataOrigin, false);

        return res;
    }

    private _GetStudentForm(dataStudent: IAlumnoGraduado): FormGenerator<IAlumnoGraduado> {
        let dataForm: IAlumnoGraduado = {
            ...dataStudent,
            ...{
                FechaNacimiento: (dataStudent.FechaNacimiento ? UIUtilTime._FmtToInputDate(dataStudent.FechaNacimiento, dataStudent.IdKinder) : dataStudent.FechaNacimiento),
                ImageIsChange: false
            }
        }

        let form = new FormGenerator<IAlumnoGraduado>();

        let initFormSchema: Array<IField<IAlumnoGraduado>> = [
            {
                type: "selectMaterial", labelText: "d_field_nombrekinder", model: "IdKinder",
                selectMaterialAttr: {
                    valueMember: "IdKinder", displayMember: "Nombre",
                    required: true,
                    onChange: (idSchool: number) => {
                        const levelCombo = form._ControlsData.get("IdEscolaridad").instance as SelectV2;
                        const gradesCombo = form._ControlsData.get("IdGrado").instance as SelectV2;
                        levelCombo._RefreshList();
                        gradesCombo._RefreshList();
                        levelCombo._disabled = idSchool == dataStudent.IdKinder;
                        gradesCombo._disabled = idSchool == dataStudent.IdKinder;

                        if (idSchool == dataStudent.IdKinder) {
                            levelCombo._valueSelect(dataStudent.IdEscolaridad);
                            gradesCombo._RefreshList();
                            gradesCombo._valueSelect(dataStudent.IdGrado);
                            form._GetIsValidForm();
                        }
                    },
                    Data: () => this._GetSchoolsWithPermission(dataForm, CAccionPermiso.Editar)
                },
            },
            {
                type: "selectMaterial", labelText: "d_field_strescolaridad", model: "IdEscolaridad",
                selectMaterialAttr: {
                    valueMember: "Id", displayMember: "Nombre",
                    required: true,
                    onChange: () => {
                        const gradesCombo = form._ControlsData.get("IdGrado").instance as SelectV2;
                        gradesCombo._RefreshList();
                    },
                    Data: () => this._GetLevelsInSchoolContext(dataStudent, form),
                },
            },
            {
                type: "selectMaterial", labelText: "d_field_strgrado", model: "IdGrado",
                selectMaterialAttr: {
                    valueMember: "IdNivel", displayMember: "Nombre",
                    required: true,
                    Data: () => this._GetGradesInLevelAndSchoolContext(dataStudent, form),
                },
            },
        ]


        form._Crear({
            schema: initFormSchema,
            LangModuleKeyInContext: "alumnosgraduados",
        }, dataForm);

        const levelCombo = form._ControlsData.get("IdEscolaridad").instance as SelectV2;
        const gradesCombo = form._ControlsData.get("IdGrado").instance as SelectV2;

        levelCombo._valueSelect(dataForm.IdEscolaridad);
        gradesCombo._RefreshList();
        gradesCombo._valueSelect(dataForm.IdGrado);

        levelCombo._disabled = true;
        gradesCombo._disabled = true;
        return form;
    }

    private _GetSchoolsWithPermission(datoAlumno: IAlumnoGraduado, action: (CAccionPermiso.Agregar | CAccionPermiso.Editar)) {
        let schoolsWithPermissionList = UIUtilPermission._GetSchoolsByActionModule(this.modulo, action);

        if (datoAlumno.IdKinder && action == CAccionPermiso.Editar && !schoolsWithPermissionList.find(d => (d.IdKinder == datoAlumno.IdKinder)) && _DICC_ESCUELA.has(datoAlumno.IdKinder)) {
            schoolsWithPermissionList.push(_DICC_ESCUELA.get(datoAlumno.IdKinder));
        }

        return schoolsWithPermissionList
    }

    private _GetLevelsInSchoolContext(dataOrigin: IAlumnoGraduado, form: FormGenerator<IAlumnoGraduado>) {
        const comboSchool = form._ControlsData.get("IdKinder").instance as SelectV2;
        let idSchool: number = comboSchool._dataValueMemberSelected[0];

        let levelsList = Array.from(_DICC_ESCOLARIDAD.values())
            .filter(dLevel => dLevel.IdEscuela == idSchool);


        if (idSchool == dataOrigin.IdKinder) {
            return levelsList.filter(dLevel => dLevel.Id == dataOrigin.IdEscolaridad);
        }

        return levelsList;
    }

    private _GetGradesInLevelAndSchoolContext(dataOrigin: IAlumnoGraduado, form: FormGenerator<IAlumnoGraduado>) {
        const comboSchool = form._ControlsData.get("IdKinder").instance as SelectV2;
        const comboLevel = form._ControlsData.get("IdEscolaridad").instance as SelectV2;

        let idSchool: number = comboSchool._dataValueMemberSelected[0];
        let idLevel: number = comboLevel._dataValueMemberSelected[0];

        let gradesList = Array.from(_DICC_GRADO.values())
            .filter(dGrade => (dGrade.IdKinder == idSchool && dGrade.IdEscolaridad == idLevel))

        if (idSchool == dataOrigin.IdKinder) {
            return gradesList.filter(dGrade => dGrade.IdNivel == dataOrigin.IdGrado)
        }

        return gradesList;
    }
}